import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { storeToRefs } from "pinia";
import { computed, onMounted } from "vue";
import { useGlobalUploadModal } from "@/composables/globalUploadModal";
import { useUploadStore } from "@/stores/uploadStore";
import localize from "@/utils/localization";
import Query from "@/utils/query-string-parsing";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UploadButton',
    props: {
        title: { default: "Download from URL or upload files from disk" }
    },
    setup(__props) {
        const props = __props;
        library.add(faUpload);
        const { openGlobalUploadModal } = useGlobalUploadModal();
        const { percentage, status } = storeToRefs(useUploadStore());
        onMounted(() => {
            if (Query.get("tool_id") == "upload1") {
                openGlobalUploadModal();
            }
        });
        const localizedTitle = computed(() => {
            return localize(props.title);
        });
        function showUploadDialog() {
            openGlobalUploadModal();
        }
        return { __sfc: true, props, openGlobalUploadModal, percentage, status, localizedTitle, showUploadDialog, FontAwesomeIcon };
    }
});
